import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import { addNotification } from 'actions/notifications';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;
import { VisibleOnlyAdmin, VisibleOnlyCustomer } from 'components/AuthenticatedComponent';
import ContentHeader from 'components/ContentHeader';
import Button from 'components/Button';
import TermsConditionsPanel from '../../components/TermsConditions/TermsConditionsPanel';
import TermsConditionsList from 'components/TermsConditions/TermsConditionsList';
import Footer from 'components/AppFooter/AppFooter'

import Loader from 'components/Loader/Loader';

import { Product } from 'models';
import { validateProduct } from 'models/validate';
import {keyedObjToArr} from "../../util";

const filesPath = 'files/terms';

class TermsConditions extends Component {

    constructor (props) {
        super(props);
        this.state = {};
    }

    createTerms () {
        this.props.openDrawer(<TermsConditionsPanel
            terms={{}}
            addTerms={this.addTerms.bind(this)}
        />);
    }

    addTerms (terms, event) {
        const { firebase } = this.props;
        firebase.push('/terms', terms);
    }

    deleteTerms (terms) {
        this.props.openModal(null, {
            message : `Are you sure you want te delete version ${terms.version}?`,
            title : 'Delete Terms',
            onClose : (result) => {
                if(result) {
                    const {firebase} = this.props;
                    firebase.deleteFile(this.props.files[terms.pdf].fullPath, `${filesPath}/${terms.pdf}`).then( (response)=> {});
                    firebase.remove(`/terms/${terms.id}`);
                }
            }
        });
    }

    render () {
        if(!isLoaded(this.props.terms) || !isLoaded(this.props.files)) {
            return (
                <div className="main-content-area">
                    <div className="page-content">
                        <Loader color="main" size="large" />
                    </div>
                </div>
            );
        }

        let button = (<Button
            label="Create Terms and Conditions"
            onClick={this.createTerms.bind(this)}
        />);

        return (
            <ReactCSSTransitionGroup
                transitionName="main-content"
                transitionAppear={true}
                transitionAppearTimeout={1500}
                transitionEnterTimeout={1500}
                transitionLeaveTimeout={1500}
                className="main-transition-wrap"
            >
                <div className="main-content-area" key="products">
                    <ContentHeader
                        title="Terms and Conditions"
                        button={button}
                    />

                    <div className="page-content">
                        <div className="container">
                            <TermsConditionsList
                                terms={this.props.terms}
                                files={this.props.files}
                                profile={this.props.profile}
                                deleteTerms={this.deleteTerms.bind(this)}
                            />
                        </div>
                        <Footer/>
                    </div>
                </div>
            </ReactCSSTransitionGroup>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
        closeDrawer : () => { dispatch(closeDrawer()); },
        openModal : (modal, props) => { dispatch(openModal(modal, props)); },
        addNotification : (key, message) => { dispatch(addNotification(key, message)); }
    };
};

const fbWrappedComponent = firebaseConnect( ({auth, profile}) => {
    return [
        {
            path: 'terms',
            storeAs: 'terms'
        },
        {
            path: 'files/terms',
            storeAs: 'files'
        }
    ];
})(TermsConditions);

//Auth
const connectAuth = connect(
    ({ firebase }) => {
        return{
            profile: pathToJS(firebase, 'profile'),
        };
    }
)(fbWrappedComponent);

export default connect(
    ({ firebase }) => ({
        profile: pathToJS(firebase, 'profile'),
        terms: dataToJS(firebase, 'terms'),
        files: dataToJS(firebase, 'files')
    }),
    mapDispatchToProps
)(connectAuth);




// WEBPACK FOOTER //
// ./js/containers/TermsConditions/TermsConditions.js